import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';

export type StatusDotPillProps = {
  children: React.ReactNode;
  /** Tailwind classes for the status dot (e.g. `bg-emerald-500`). */
  dotClassName?: string;
  title?: string;
  className?: string;
  /** Hide the colored dot. */
  hideDot?: boolean;
};

/**
 * Compact bordered status pill with an optional colored dot — used in list/table status cells.
 */
export function StatusDotPill({
  children,
  dotClassName,
  title,
  className,
  hideDot = false,
}: StatusDotPillProps) {
  const { colors } = useTheme();

  return (
    <div
      className={cn(
        'inline-flex max-w-full items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold tracking-tight',
        colors.border,
        colors.surface,
        colors.text,
        className,
      )}
      title={title}
    >
      {!hideDot && (
        <span
          className={cn(
            'h-1.5 w-1.5 shrink-0 rounded-full ring-1 ring-black/10 dark:ring-white/15',
            dotClassName ?? 'bg-slate-400',
          )}
          aria-hidden
        />
      )}
      <span className="min-w-0 truncate">{children}</span>
    </div>
  );
}

export default StatusDotPill;
